import { html, TemplateResult, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import globalStyles from './styles/outline-icon.global.pcss?inline';
import encapsulatedStyles from './styles/outline-icon.encapsulated.pcss?inline';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import { classMap } from 'lit/directives/class-map.js';
import { extractIconClassNames } from '../../utilities/icon-utilities';
/**
 * The element name, reused throughout the codebase
 * @type {string}
 */
const componentName = 'outline-icon';

/**
 * The Outline Core Icon component
 *
 * A reusable LitElement component for displaying icons.
 *
 * @element outline-icon
 * @extends LitElement
 */
@customElement(componentName)
export class OutlineIcon extends LitElement {
  /**
   * Adopted stylesheets for the component
   *
   * @type {AdoptedStyleSheets}
   */
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    globalCSS: globalStyles,
    encapsulatedCSS: encapsulatedStyles,
  });

  @property({type: String})
  icon: string;

  @property({type: String})
  color: string
  
  @property({type: String})
  size: string;

  classArray: Array<string>;

  connectedCallback() {
    super.connectedCallback();
    this.updateVarsAndClasses();
  }

  updateVarsAndClasses() {
    if(this.size) {
      this.style.setProperty('--icon-size', `${this.size}`)
    }
    if (this.color) {
      this.style.setProperty('--icon-color', `${this.color}`)
    }
    this.classArray = extractIconClassNames(this.icon);
    if (!this.classArray.length) {
      this.classArray = this.icon.split(' ');
    }
  }
  
  updated() {
    this.updateVarsAndClasses();
  }

  render(): TemplateResult {
    const iconClasses: Record<string, boolean> = {};    
    this.classArray?.forEach((cls: keyof typeof iconClasses) => iconClasses[cls] = true)
    return html`
    <link rel="stylesheet" href="https://kit.fontawesome.com/e40642b092.css" />
    
    <div class="outline-icon">
      <i class="${classMap(iconClasses)}"></i>
    </div>
    `;
  }
}

/**
 * Declare the component in the global HTMLElementTagNameMap
 */
declare global {
  interface HTMLElementTagNameMap {
    [componentName]: OutlineIcon;
  }
}
